import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { PeopleCardEntity } from '../PeopleCardEntity/PeopleCardEntity.esm.js';
import { makeStyles } from '@material-ui/core/styles';
import ArrowIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => ({
  link: {
    color: "inherit",
    textDecoration: "none",
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0)
  },
  box: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1)
  },
  boxLink: {
    marginTop: theme.spacing(0)
  },
  title: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0)
  }
}));
const PeopleList = ({ title, peopleObj, deepLink }) => {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Box,
    {
      className: classes.box,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    /* @__PURE__ */ React.createElement("h2", { className: classes.title }, title),
    deepLink && /* @__PURE__ */ React.createElement(
      Box,
      {
        className: classes.boxLink,
        display: "flex",
        alignItems: "center"
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          className: classes.link,
          to: deepLink.link,
          onClick: deepLink.onClick
        },
        deepLink.title
      ),
      /* @__PURE__ */ React.createElement(ArrowIcon, { fontSize: "small" })
    )
  ), /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 1, justifyContent: "flex-start" }, peopleObj == null ? void 0 : peopleObj.map((peopleCardEntity) => /* @__PURE__ */ React.createElement(
    Grid,
    {
      key: peopleCardEntity.email || peopleCardEntity.name,
      item: true
    },
    /* @__PURE__ */ React.createElement(PeopleCardEntity, { peopleCardEntity })
  ))));
};

export { PeopleList };
//# sourceMappingURL=PeopleList.esm.js.map
